var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.absoluteValue),function(n){return _c('v-icon',{key:n,attrs:{"small":""}},[_vm._v("mdi-star")])}),(_vm.showHalfStar)?_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-star-half")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }